import { Component, computed, input } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { dsDtos } from '@vectronic/openApi-admin';
import { webDtos } from '@vectronic/openApi-customer';
import { Translator } from '@vectronic/util';

@Component({
  selector: 'rc-command-time-line',
  templateUrl: './command-time-line.component.html',
  styleUrls: ['./command-time-line.component.scss'],
  imports: [MatCard, MatCardContent, MatIcon],
})
export class CommandTimeLineComponent {
  command = input<dsDtos.Command | webDtos.CustomerCommand>();

  createdDate = computed(() => {
    const command = this.command();
    if (command && 'createdBy' in command) {
      return command.createdBy !== -1 ? Translator.utcDate(this.command().insertTs) : '';
    }
    return Translator.utcDate(this.command().insertTs);
  });
  sendToDeviceTime = computed(() =>
    this.command().sendToDeviceTime ? Translator.utcDate(this.command().sendToDeviceTime) : '',
  );
  receivedResponseTime = computed(() =>
    this.command().receivedResponseTime
      ? Translator.utcDate(this.command().receivedResponseTime)
      : '',
  );
  commandState = computed(() => this.command().commandState);
  hasSentCommand = computed(
    () =>
      this.commandState() === 'SENT_TO_DEVICE' ||
      this.commandState() === 'ACKNOWLEDGED' ||
      this.commandState() === 'FAILED_EXPIRED' ||
      this.commandState() === 'FAILED_ON_DEVICE',
  );
  hasFailedSentToDeviceCommand = computed(() => this.commandState() === 'FAILED_SENDING_TO_DEVICE');
  hasSentToServerCommand = computed(() => this.commandState() === 'SENT_TO_SERVER');
  hasFailedSentToServerCommand = computed(() => this.commandState() === 'FAILED_SENDING_TO_SERVER');
  hasCanceledCommand = computed(() => this.commandState() === 'CANCELED');
  hasAcknowledgedCommand = computed(() => this.commandState() === 'ACKNOWLEDGED');
  hasFailedExpiredCommand = computed(() => this.commandState() === 'FAILED_EXPIRED');
  hasFailedOnDeviceCommand = computed(() => this.commandState() === 'FAILED_ON_DEVICE');
}
